import React from "react";
import "../../pages/style.css";
import ProjectCard from "./ProjectCard";
import { Container, Row, Col } from "react-bootstrap";
import expenseImage from "../../Assets/Exp.jpg";
import eccomerseImage from "../../Assets/Ecommerse.jpg";
import mailboxImage from "../../Assets/MailBox.jpg";

const Projectlist = () => {
  return (
    <div className="projectbackground">
      <Container fluid className="project-section">
        <Container>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={expenseImage}
                isBlog={false}
                title="Expense-Tracker"
                description="Revolutionize your expense tracking with Expense Tracker. Our advanced application, built using HTML, CSS, JavaScript, ReactJS, Redux, Firebase, and TailwindCSS seamless usability and top-notch data security. Monitor and analyze expenses effortlessly, with premium features like Excel data downloads and customizable themes. Streamline your financial management today."
                ghLink="https://expense-236e0.web.app/"
                git="https://github.com/Chiksinafees/Expense-Tracker"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={eccomerseImage}
                isBlog={false}
                title="E-commerse website"
                description="Experience seamless online shopping with our E-commerce website. Browse and add products to your cart effortlessly, while enjoying secure login access for a personalized experience. Our frontend, powered by HTML, CSS, and ReactJS, Crudcrud, Context-Api, Firebase which ensures a smooth browsing and shopping journey. Rest easy with robust authentication and real-time data storage through Firebase. Elevate your online business today!"
                ghLink="https://e-commerse-8afc7.web.app/Logout"
                git="https://github.com/Chiksinafees/Ecommerse-website"
              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                imgPath={mailboxImage}
                isBlog={false}
                title="MailBox-client"
                description="Introducing Mailbox Client, the ultimate email application for seamless communication. Enjoy secure, private accounts with no data sharing. Our frontend, powered by HTML, TailwindCSS, JavaScript, React, Firebase, Rest-Api, and Redux, ensures a user-friendly experience. Leveraging advanced Firebase requests, access and modify user-specific information effortlessly . Upgrade your email management with Mailbox Client today."
                ghLink="https://mail-box-b419a.web.app"
                git="https://github.com/Chiksinafees/Mail-Box-client"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
};
export default Projectlist;
